export function emptyPromise() {
  let res;
  let rej;
  const p = new Promise((resolve, reject) => {
    res = resolve;
    rej = reject;
  });
  p.pending = true;
  p.resolved = p.rejected = null;
  p.resolve = (...args) => {
    res(...args); p.resolved = true; p.rejected = false; p.pending = false;
  };
  p.reject = (...args) => {
    rej(...args); p.rejected = true; p.resolved = false; p.pending = false;
  };
  return p;
}

export async function tryRequest(p) {
  try {
    const response = await p;
    return response.data;
  } catch (e) {
    if (!e.response) {
      logger.error('issue connecting to server', e);
    }
    logger.log(e);
    throw e;
  }
}

export function updateInList(list, selector, change) {
  // return a new list produced by calling change()
  // on the (single) value matching selector.

  // change() is given the current value as its only argument.
  const ix = _.findIndex(list, selector);
  if (ix < 0) return list;
  return [
    ...list.slice(0, ix),
    change(list[ix]),
    ...list.slice(ix + 1, list.length),
  ];
}



//////////////////
// WEBPACK FOOTER
// ../shared/utilities.js
// module id = null
// module chunks = 